import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const periodWrap: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  [mobile]: {
    width: '100%',
  },
};

const period: CSSObject = {
  width: 140,
  '> div': { minWidth: 0 },
  [mobile]: {
    flex: 1,
    width: 'auto',
  },
};

const tilde: CSSObject = {
  color: theme.color.grey400,
};

export { periodWrap, period, tilde };
